// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file workspace/workspace.proto (package lvdr.v2.workspace, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file workspace/workspace.proto.
 */
export const file_workspace_workspace: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * MountWorkspaceRequest carries the client-unwrapped WS-DEK over the secure WS
 * channel (E1 Phase 3). The server validates the caller's grant, caches the DEK
 * in the session keyring, and lazily opens the Workspace's encrypted store.
 *
 * @generated from message lvdr.v2.workspace.MountWorkspaceRequest
 */
export type MountWorkspaceRequest = Message<"lvdr.v2.workspace.MountWorkspaceRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * client-unwrapped 32-byte WS-DEK
   *
   * @generated from field: bytes ws_dek = 2;
   */
  wsDek: Uint8Array;

  /**
   * AON-03: mount without becoming the session's active workspace (the always-on auto-mount)
   *
   * @generated from field: bool keep_active_workspace = 3;
   */
  keepActiveWorkspace: boolean;
};

/**
 * Describes the message lvdr.v2.workspace.MountWorkspaceRequest.
 * Use `create(MountWorkspaceRequestSchema)` to create a new message.
 */
export const MountWorkspaceRequestSchema: GenMessage<MountWorkspaceRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 0);

/**
 * @generated from message lvdr.v2.workspace.MountWorkspaceResponse
 */
export type MountWorkspaceResponse = Message<"lvdr.v2.workspace.MountWorkspaceResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * "read" | "read_write"
   *
   * @generated from field: string access_level = 2;
   */
  accessLevel: string;

  /**
   * "mounted"
   *
   * @generated from field: string status = 3;
   */
  status: string;

  /**
   * MEM-09m: the island is held by another backend (writes refused)
   *
   * @generated from field: bool peer_owned = 4;
   */
  peerOwned: boolean;
};

/**
 * Describes the message lvdr.v2.workspace.MountWorkspaceResponse.
 * Use `create(MountWorkspaceResponseSchema)` to create a new message.
 */
export const MountWorkspaceResponseSchema: GenMessage<MountWorkspaceResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 1);

/**
 * @generated from message lvdr.v2.workspace.UnmountWorkspaceRequest
 */
export type UnmountWorkspaceRequest = Message<"lvdr.v2.workspace.UnmountWorkspaceRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.workspace.UnmountWorkspaceRequest.
 * Use `create(UnmountWorkspaceRequestSchema)` to create a new message.
 */
export const UnmountWorkspaceRequestSchema: GenMessage<UnmountWorkspaceRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 2);

/**
 * @generated from message lvdr.v2.workspace.UnmountWorkspaceResponse
 */
export type UnmountWorkspaceResponse = Message<"lvdr.v2.workspace.UnmountWorkspaceResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * "unmounted"
   *
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.workspace.UnmountWorkspaceResponse.
 * Use `create(UnmountWorkspaceResponseSchema)` to create a new message.
 */
export const UnmountWorkspaceResponseSchema: GenMessage<UnmountWorkspaceResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 3);

/**
 * RekeyWorkspaceRequest triggers a Phase-4 revocation re-key. The caller must
 * be an authorized key-holder (owner / org-admin) with the workspace currently
 * mounted — the server consumes the old WS-DEK from that session's keyring,
 * generates a new one, re-encrypts the island, and re-wraps to every remaining
 * member device.
 *
 * @generated from message lvdr.v2.workspace.RekeyWorkspaceRequest
 */
export type RekeyWorkspaceRequest = Message<"lvdr.v2.workspace.RekeyWorkspaceRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.workspace.RekeyWorkspaceRequest.
 * Use `create(RekeyWorkspaceRequestSchema)` to create a new message.
 */
export const RekeyWorkspaceRequestSchema: GenMessage<RekeyWorkspaceRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 4);

/**
 * @generated from message lvdr.v2.workspace.RekeyWorkspaceResponse
 */
export type RekeyWorkspaceResponse = Message<"lvdr.v2.workspace.RekeyWorkspaceResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * "rekeyed" — client must re-fetch + unwrap the NEW DEK and re-mount
   *
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.workspace.RekeyWorkspaceResponse.
 * Use `create(RekeyWorkspaceResponseSchema)` to create a new message.
 */
export const RekeyWorkspaceResponseSchema: GenMessage<RekeyWorkspaceResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 5);

/**
 * SetActiveWorkspaceRequest switches the session's active billing-context Workspace
 * (E1 Phase 8). The workspace must already be mounted in this session. An empty
 * workspace_id clears the active context (subsequent billable actions draw from the
 * org pool untagged). Mounting a workspace already sets it active; this is the explicit
 * mid-session switch when several workspaces are mounted at once.
 *
 * @generated from message lvdr.v2.workspace.SetActiveWorkspaceRequest
 */
export type SetActiveWorkspaceRequest = Message<"lvdr.v2.workspace.SetActiveWorkspaceRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.workspace.SetActiveWorkspaceRequest.
 * Use `create(SetActiveWorkspaceRequestSchema)` to create a new message.
 */
export const SetActiveWorkspaceRequestSchema: GenMessage<SetActiveWorkspaceRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 6);

/**
 * @generated from message lvdr.v2.workspace.SetActiveWorkspaceResponse
 */
export type SetActiveWorkspaceResponse = Message<"lvdr.v2.workspace.SetActiveWorkspaceResponse"> & {
  /**
   * the now-active workspace ("" when cleared)
   *
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * "active" | "cleared"
   *
   * @generated from field: string status = 2;
   */
  status: string;
};

/**
 * Describes the message lvdr.v2.workspace.SetActiveWorkspaceResponse.
 * Use `create(SetActiveWorkspaceResponseSchema)` to create a new message.
 */
export const SetActiveWorkspaceResponseSchema: GenMessage<SetActiveWorkspaceResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 7);

/**
 * AreaRef names one side of a transfer: a user's personal area, or a shared
 * Workspace island. kind is "personal" | "workspace". workspace_id is set only
 * for a workspace area.
 *
 * @generated from message lvdr.v2.workspace.AreaRef
 */
export type AreaRef = Message<"lvdr.v2.workspace.AreaRef"> & {
  /**
   * "personal" | "workspace"
   *
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * set only when kind == "workspace"
   *
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.workspace.AreaRef.
 * Use `create(AreaRefSchema)` to create a new message.
 */
export const AreaRefSchema: GenMessage<AreaRef> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 8);

/**
 * TransferItem identifies a single whole item to transfer. kind is
 * "document" | "note" | "research".
 *
 * @generated from message lvdr.v2.workspace.TransferItem
 */
export type TransferItem = Message<"lvdr.v2.workspace.TransferItem"> & {
  /**
   * @generated from field: string kind = 1;
   */
  kind: string;

  /**
   * @generated from field: string id = 2;
   */
  id: string;
};

/**
 * Describes the message lvdr.v2.workspace.TransferItem.
 * Use `create(TransferItemSchema)` to create a new message.
 */
export const TransferItemSchema: GenMessage<TransferItem> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 9);

/**
 * TransferContentRequest moves or copies one item between areas (E1 Phase 7).
 * Into a shared Workspace it requires confirm=true after the client has shown
 * the exposure preview; without it the server replies status="consent_required"
 * carrying exposed_member_count, and the client re-submits with confirm=true.
 *
 * @generated from message lvdr.v2.workspace.TransferContentRequest
 */
export type TransferContentRequest = Message<"lvdr.v2.workspace.TransferContentRequest"> & {
  /**
   * @generated from field: lvdr.v2.workspace.AreaRef source = 1;
   */
  source?: AreaRef | undefined;

  /**
   * @generated from field: lvdr.v2.workspace.AreaRef target = 2;
   */
  target?: AreaRef | undefined;

  /**
   * @generated from field: lvdr.v2.workspace.TransferItem item = 3;
   */
  item?: TransferItem | undefined;

  /**
   * "copy" | "move"
   *
   * @generated from field: string mode = 4;
   */
  mode: string;

  /**
   * explicit consent to expose into a shared workspace
   *
   * @generated from field: bool confirm = 5;
   */
  confirm: boolean;

  /**
   * MEM-09n: Workspace node the item lands on; "" ⇒ Unsorted (R7)
   *
   * @generated from field: string target_node_id = 6;
   */
  targetNodeId: string;
};

/**
 * Describes the message lvdr.v2.workspace.TransferContentRequest.
 * Use `create(TransferContentRequestSchema)` to create a new message.
 */
export const TransferContentRequestSchema: GenMessage<TransferContentRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 10);

/**
 * TransferContentResponse is the synchronous ack. status is "consent_required"
 * (re-submit with confirm) or "accepted" (the transfer runs async; a
 * TransferContentCompletedEvent follows on the same connection).
 *
 * @generated from message lvdr.v2.workspace.TransferContentResponse
 */
export type TransferContentResponse = Message<"lvdr.v2.workspace.TransferContentResponse"> & {
  /**
   * "consent_required" | "accepted" | "refused" (AON-06)
   *
   * @generated from field: string status = 1;
   */
  status: string;

  /**
   * members who would gain access (consent_required)
   *
   * @generated from field: int32 exposed_member_count = 2;
   */
  exposedMemberCount: number;

  /**
   * set when status == "accepted"
   *
   * @generated from field: string transfer_id = 3;
   */
  transferId: string;

  /**
   * AON-06: set together with status == "refused". One of
   * "copy_into_always_on" | "not_movable_yet" | "note_exists" | "always_on_refused".
   *
   * @generated from field: string error_code = 4;
   */
  errorCode: string;
};

/**
 * Describes the message lvdr.v2.workspace.TransferContentResponse.
 * Use `create(TransferContentResponseSchema)` to create a new message.
 */
export const TransferContentResponseSchema: GenMessage<TransferContentResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 11);

/**
 * TransferContentCompletedEvent is pushed when an accepted transfer finishes
 * (success or failure) — the transfer runs on a detached goroutine so a large
 * research copy never blocks the connection's read loop.
 *
 * @generated from message lvdr.v2.workspace.TransferContentCompletedEvent
 */
export type TransferContentCompletedEvent = Message<"lvdr.v2.workspace.TransferContentCompletedEvent"> & {
  /**
   * @generated from field: string transfer_id = 1;
   */
  transferId: string;

  /**
   * "transferred" | "failed"
   *
   * @generated from field: string status = 2;
   */
  status: string;

  /**
   * set when status == "failed"
   *
   * @generated from field: string error = 3;
   */
  error: string;

  /**
   * nodes written into the target island
   *
   * @generated from field: int32 node_count = 4;
   */
  nodeCount: number;

  /**
   * AON-06: machine-readable reason when status == "failed". One of
   * "copy_into_always_on" | "not_movable_yet" | "note_exists" | "always_on_refused".
   *
   * @generated from field: string error_code = 5;
   */
  errorCode: string;
};

/**
 * Describes the message lvdr.v2.workspace.TransferContentCompletedEvent.
 * Use `create(TransferContentCompletedEventSchema)` to create a new message.
 */
export const TransferContentCompletedEventSchema: GenMessage<TransferContentCompletedEvent> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 12);

/**
 * WorkspaceNotificationEvent is the server→client push when a notification is
 * created for an online recipient (E1 Phase 11). CRUD (list/read/claim/create/
 * done/subscribe) is over HTTP /api/v2/workspaces/:id/...; this is the only WS
 * message. read_at is omitted — a pushed notification is always unread.
 *
 * @generated from message lvdr.v2.workspace.WorkspaceNotificationEvent
 */
export type WorkspaceNotificationEvent = Message<"lvdr.v2.workspace.WorkspaceNotificationEvent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * "fyi" | "handover" | "hitl" | "step"
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * @generated from field: string title = 4;
   */
  title: string;

  /**
   * @generated from field: string body = 5;
   */
  body: string;

  /**
   * optional deep-link target kind
   *
   * @generated from field: string ref_kind = 6;
   */
  refKind: string;

  /**
   * optional deep-link target id
   *
   * @generated from field: string ref_id = 7;
   */
  refId: string;

  /**
   * set when kind == "handover"
   *
   * @generated from field: string handover_id = 8;
   */
  handoverId: string;

  /**
   * RFC3339
   *
   * @generated from field: string created_at = 9;
   */
  createdAt: string;
};

/**
 * Describes the message lvdr.v2.workspace.WorkspaceNotificationEvent.
 * Use `create(WorkspaceNotificationEventSchema)` to create a new message.
 */
export const WorkspaceNotificationEventSchema: GenMessage<WorkspaceNotificationEvent> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 13);

/**
 * WorkspaceNote is a MUTABLE note authored inside a Workspace island, distinct
 * from the immutable Phase-7 transfer snapshots. `version` drives optimistic
 * concurrency control (OCC). `sensitivity` is reserved for a future per-note
 * clearance gate — unused in v1, where the workspace grant is the access gate.
 *
 * @generated from message lvdr.v2.workspace.WorkspaceNote
 */
export type WorkspaceNote = Message<"lvdr.v2.workspace.WorkspaceNote"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * @generated from field: string title = 3;
   */
  title: string;

  /**
   * @generated from field: string content = 4;
   */
  content: string;

  /**
   * @generated from field: repeated string tags = 5;
   */
  tags: string[];

  /**
   * @generated from field: bool pinned = 6;
   */
  pinned: boolean;

  /**
   * OCC version; new notes start at 1
   *
   * @generated from field: int32 version = 7;
   */
  version: number;

  /**
   * reserved (v1: floor)
   *
   * @generated from field: int32 sensitivity = 8;
   */
  sensitivity: number;

  /**
   * RFC3339
   *
   * @generated from field: string created_at = 9;
   */
  createdAt: string;

  /**
   * RFC3339
   *
   * @generated from field: string updated_at = 10;
   */
  updatedAt: string;

  /**
   * user id of the last writer
   *
   * @generated from field: string updated_by = 11;
   */
  updatedBy: string;

  /**
   * NOTES-16: the write_token of the write that produced this version, or ""
   *
   * @generated from field: string last_write_token = 12;
   */
  lastWriteToken: string;
};

/**
 * Describes the message lvdr.v2.workspace.WorkspaceNote.
 * Use `create(WorkspaceNoteSchema)` to create a new message.
 */
export const WorkspaceNoteSchema: GenMessage<WorkspaceNote> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 14);

/**
 * @generated from message lvdr.v2.workspace.CreateWorkspaceNoteRequest
 */
export type CreateWorkspaceNoteRequest = Message<"lvdr.v2.workspace.CreateWorkspaceNoteRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string content = 3;
   */
  content: string;

  /**
   * @generated from field: repeated string tags = 4;
   */
  tags: string[];
};

/**
 * Describes the message lvdr.v2.workspace.CreateWorkspaceNoteRequest.
 * Use `create(CreateWorkspaceNoteRequestSchema)` to create a new message.
 */
export const CreateWorkspaceNoteRequestSchema: GenMessage<CreateWorkspaceNoteRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 15);

/**
 * @generated from message lvdr.v2.workspace.GetWorkspaceNoteRequest
 */
export type GetWorkspaceNoteRequest = Message<"lvdr.v2.workspace.GetWorkspaceNoteRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string note_id = 2;
   */
  noteId: string;
};

/**
 * Describes the message lvdr.v2.workspace.GetWorkspaceNoteRequest.
 * Use `create(GetWorkspaceNoteRequestSchema)` to create a new message.
 */
export const GetWorkspaceNoteRequestSchema: GenMessage<GetWorkspaceNoteRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 16);

/**
 * @generated from message lvdr.v2.workspace.ListWorkspaceNotesRequest
 */
export type ListWorkspaceNotesRequest = Message<"lvdr.v2.workspace.ListWorkspaceNotesRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.workspace.ListWorkspaceNotesRequest.
 * Use `create(ListWorkspaceNotesRequestSchema)` to create a new message.
 */
export const ListWorkspaceNotesRequestSchema: GenMessage<ListWorkspaceNotesRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 17);

/**
 * @generated from message lvdr.v2.workspace.ListWorkspaceNotesResponse
 */
export type ListWorkspaceNotesResponse = Message<"lvdr.v2.workspace.ListWorkspaceNotesResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: repeated lvdr.v2.workspace.WorkspaceNote notes = 2;
   */
  notes: WorkspaceNote[];
};

/**
 * Describes the message lvdr.v2.workspace.ListWorkspaceNotesResponse.
 * Use `create(ListWorkspaceNotesResponseSchema)` to create a new message.
 */
export const ListWorkspaceNotesResponseSchema: GenMessage<ListWorkspaceNotesResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 18);

/**
 * UpdateWorkspaceNoteRequest carries OCC `expected_version` (the version the
 * client last saw). Scalar edits are `optional` so an unsent field is left
 * unchanged (a proto empty-string would otherwise erase it); `has_tags` guards
 * the repeated tags replacement.
 *
 * @generated from message lvdr.v2.workspace.UpdateWorkspaceNoteRequest
 */
export type UpdateWorkspaceNoteRequest = Message<"lvdr.v2.workspace.UpdateWorkspaceNoteRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string note_id = 2;
   */
  noteId: string;

  /**
   * @generated from field: int32 expected_version = 3;
   */
  expectedVersion: number;

  /**
   * @generated from field: optional string title = 4;
   */
  title?: string | undefined;

  /**
   * @generated from field: optional string content = 5;
   */
  content?: string | undefined;

  /**
   * @generated from field: bool has_tags = 6;
   */
  hasTags: boolean;

  /**
   * @generated from field: repeated string tags = 7;
   */
  tags: string[];

  /**
   * @generated from field: optional bool pinned = 8;
   */
  pinned?: boolean | undefined;

  /**
   * NOTES-16: the outbox episode token (NOTES-21 D7); "" from an old client
   *
   * @generated from field: string write_token = 9;
   */
  writeToken: string;
};

/**
 * Describes the message lvdr.v2.workspace.UpdateWorkspaceNoteRequest.
 * Use `create(UpdateWorkspaceNoteRequestSchema)` to create a new message.
 */
export const UpdateWorkspaceNoteRequestSchema: GenMessage<UpdateWorkspaceNoteRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 19);

/**
 * @generated from message lvdr.v2.workspace.DeleteWorkspaceNoteRequest
 */
export type DeleteWorkspaceNoteRequest = Message<"lvdr.v2.workspace.DeleteWorkspaceNoteRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string note_id = 2;
   */
  noteId: string;

  /**
   * @generated from field: int32 expected_version = 3;
   */
  expectedVersion: number;
};

/**
 * Describes the message lvdr.v2.workspace.DeleteWorkspaceNoteRequest.
 * Use `create(DeleteWorkspaceNoteRequestSchema)` to create a new message.
 */
export const DeleteWorkspaceNoteRequestSchema: GenMessage<DeleteWorkspaceNoteRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 20);

/**
 * WorkspaceNoteResponse is the create/get/update reply. On a stale OCC update,
 * `stale_version=true` and `note` carries the CURRENT server state so the client
 * can reload/merge.
 *
 * @generated from message lvdr.v2.workspace.WorkspaceNoteResponse
 */
export type WorkspaceNoteResponse = Message<"lvdr.v2.workspace.WorkspaceNoteResponse"> & {
  /**
   * @generated from field: lvdr.v2.workspace.WorkspaceNote note = 1;
   */
  note?: WorkspaceNote | undefined;

  /**
   * @generated from field: bool stale_version = 2;
   */
  staleVersion: boolean;
};

/**
 * Describes the message lvdr.v2.workspace.WorkspaceNoteResponse.
 * Use `create(WorkspaceNoteResponseSchema)` to create a new message.
 */
export const WorkspaceNoteResponseSchema: GenMessage<WorkspaceNoteResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 21);

/**
 * @generated from message lvdr.v2.workspace.DeleteWorkspaceNoteResponse
 */
export type DeleteWorkspaceNoteResponse = Message<"lvdr.v2.workspace.DeleteWorkspaceNoteResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string note_id = 2;
   */
  noteId: string;

  /**
   * @generated from field: bool stale_version = 3;
   */
  staleVersion: boolean;

  /**
   * current state when stale_version=true
   *
   * @generated from field: lvdr.v2.workspace.WorkspaceNote note = 4;
   */
  note?: WorkspaceNote | undefined;
};

/**
 * Describes the message lvdr.v2.workspace.DeleteWorkspaceNoteResponse.
 * Use `create(DeleteWorkspaceNoteResponseSchema)` to create a new message.
 */
export const DeleteWorkspaceNoteResponseSchema: GenMessage<DeleteWorkspaceNoteResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 22);

/**
 * WorkspaceChangeEvent is the metadata-only server→client push telling mounted
 * members an island item changed; the client refetches through the clearance-
 * filtered serve path. It NEVER carries content bytes.
 *
 * @generated from message lvdr.v2.workspace.WorkspaceChangeEvent
 */
export type WorkspaceChangeEvent = Message<"lvdr.v2.workspace.WorkspaceChangeEvent"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * "note" | "document" | "transfer" | "membership" | "workspace"
   *
   * @generated from field: string item_kind = 2;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * "created" | "updated" | "deleted" | "granted" | "revoked" | "rekeyed"
   *
   * @generated from field: string op = 4;
   */
  op: string;

  /**
   * @generated from field: int32 version = 5;
   */
  version: number;

  /**
   * @generated from field: string actor_user_id = 6;
   */
  actorUserId: string;
};

/**
 * Describes the message lvdr.v2.workspace.WorkspaceChangeEvent.
 * Use `create(WorkspaceChangeEventSchema)` to create a new message.
 */
export const WorkspaceChangeEventSchema: GenMessage<WorkspaceChangeEvent> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 23);

/**
 * PresenceEvent rides the same sync fan-out: who is editing what (advisory).
 *
 * @generated from message lvdr.v2.workspace.PresenceEvent
 */
export type PresenceEvent = Message<"lvdr.v2.workspace.PresenceEvent"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: string actor_user_id = 3;
   */
  actorUserId: string;

  /**
   * @generated from field: string display_name = 4;
   */
  displayName: string;

  /**
   * "editing" | "released"
   *
   * @generated from field: string state = 5;
   */
  state: string;
};

/**
 * Describes the message lvdr.v2.workspace.PresenceEvent.
 * Use `create(PresenceEventSchema)` to create a new message.
 */
export const PresenceEventSchema: GenMessage<PresenceEvent> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 24);

/**
 * AcquireEditLockRequest takes the advisory soft-lock on a workspace note. The
 * lock is a hint (OCC is the real guard); a held lock returns acquired=false +
 * the current holder.
 *
 * @generated from message lvdr.v2.workspace.AcquireEditLockRequest
 */
export type AcquireEditLockRequest = Message<"lvdr.v2.workspace.AcquireEditLockRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;
};

/**
 * Describes the message lvdr.v2.workspace.AcquireEditLockRequest.
 * Use `create(AcquireEditLockRequestSchema)` to create a new message.
 */
export const AcquireEditLockRequestSchema: GenMessage<AcquireEditLockRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 25);

/**
 * @generated from message lvdr.v2.workspace.AcquireEditLockResponse
 */
export type AcquireEditLockResponse = Message<"lvdr.v2.workspace.AcquireEditLockResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: bool acquired = 3;
   */
  acquired: boolean;

  /**
   * set when acquired=false
   *
   * @generated from field: string holder_user_id = 4;
   */
  holderUserId: string;

  /**
   * @generated from field: string holder_display_name = 5;
   */
  holderDisplayName: string;

  /**
   * @generated from field: int32 ttl_seconds = 6;
   */
  ttlSeconds: number;
};

/**
 * Describes the message lvdr.v2.workspace.AcquireEditLockResponse.
 * Use `create(AcquireEditLockResponseSchema)` to create a new message.
 */
export const AcquireEditLockResponseSchema: GenMessage<AcquireEditLockResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 26);

/**
 * @generated from message lvdr.v2.workspace.ReleaseEditLockRequest
 */
export type ReleaseEditLockRequest = Message<"lvdr.v2.workspace.ReleaseEditLockRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;
};

/**
 * Describes the message lvdr.v2.workspace.ReleaseEditLockRequest.
 * Use `create(ReleaseEditLockRequestSchema)` to create a new message.
 */
export const ReleaseEditLockRequestSchema: GenMessage<ReleaseEditLockRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 27);

/**
 * @generated from message lvdr.v2.workspace.ReleaseEditLockResponse
 */
export type ReleaseEditLockResponse = Message<"lvdr.v2.workspace.ReleaseEditLockResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string item_id = 2;
   */
  itemId: string;

  /**
   * @generated from field: bool released = 3;
   */
  released: boolean;
};

/**
 * Describes the message lvdr.v2.workspace.ReleaseEditLockResponse.
 * Use `create(ReleaseEditLockResponseSchema)` to create a new message.
 */
export const ReleaseEditLockResponseSchema: GenMessage<ReleaseEditLockResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 28);

/**
 * SnapshotTag records one external real-world event pinned to a frozen snapshot
 * (served / executed / filed …). Append-only; the content never changes.
 *
 * @generated from message lvdr.v2.workspace.SnapshotTag
 */
export type SnapshotTag = Message<"lvdr.v2.workspace.SnapshotTag"> & {
  /**
   * @generated from field: string event_type = 1;
   */
  eventType: string;

  /**
   * ISO date of the external event
   *
   * @generated from field: string date = 2;
   */
  date: string;

  /**
   * @generated from field: string counterparty = 3;
   */
  counterparty: string;

  /**
   * @generated from field: string note = 4;
   */
  note: string;
};

/**
 * Describes the message lvdr.v2.workspace.SnapshotTag.
 * Use `create(SnapshotTagSchema)` to create a new message.
 */
export const SnapshotTagSchema: GenMessage<SnapshotTag> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 29);

/**
 * Snapshot is the metadata of one immutable freeze. The frozen plaintext lives
 * write-once in the island store; content_hash is sha256 over that plaintext.
 *
 * @generated from message lvdr.v2.workspace.Snapshot
 */
export type Snapshot = Message<"lvdr.v2.workspace.Snapshot"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string workspace_id = 2;
   */
  workspaceId: string;

  /**
   * "note" | "document"
   *
   * @generated from field: string item_kind = 3;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 4;
   */
  itemId: string;

  /**
   * @generated from field: string content_hash = 5;
   */
  contentHash: string;

  /**
   * @generated from field: repeated lvdr.v2.workspace.SnapshotTag tags = 6;
   */
  tags: SnapshotTag[];

  /**
   * @generated from field: string notes = 7;
   */
  notes: string;

  /**
   * @generated from field: bool legal_hold = 8;
   */
  legalHold: boolean;

  /**
   * @generated from field: string created_by = 9;
   */
  createdBy: string;

  /**
   * RFC3339
   *
   * @generated from field: string created_at = 10;
   */
  createdAt: string;
};

/**
 * Describes the message lvdr.v2.workspace.Snapshot.
 * Use `create(SnapshotSchema)` to create a new message.
 */
export const SnapshotSchema: GenMessage<Snapshot> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 30);

/**
 * @generated from message lvdr.v2.workspace.CreateSnapshotRequest
 */
export type CreateSnapshotRequest = Message<"lvdr.v2.workspace.CreateSnapshotRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * "note" | "document"
   *
   * @generated from field: string item_kind = 2;
   */
  itemKind: string;

  /**
   * @generated from field: string item_id = 3;
   */
  itemId: string;

  /**
   * @generated from field: repeated lvdr.v2.workspace.SnapshotTag tags = 4;
   */
  tags: SnapshotTag[];

  /**
   * @generated from field: string notes = 5;
   */
  notes: string;
};

/**
 * Describes the message lvdr.v2.workspace.CreateSnapshotRequest.
 * Use `create(CreateSnapshotRequestSchema)` to create a new message.
 */
export const CreateSnapshotRequestSchema: GenMessage<CreateSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 31);

/**
 * @generated from message lvdr.v2.workspace.GetSnapshotRequest
 */
export type GetSnapshotRequest = Message<"lvdr.v2.workspace.GetSnapshotRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId: string;
};

/**
 * Describes the message lvdr.v2.workspace.GetSnapshotRequest.
 * Use `create(GetSnapshotRequestSchema)` to create a new message.
 */
export const GetSnapshotRequestSchema: GenMessage<GetSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 32);

/**
 * SnapshotContentResponse returns a snapshot's metadata AND its verified frozen
 * content (GetSnapshot recomputes the hash before returning).
 *
 * @generated from message lvdr.v2.workspace.SnapshotContentResponse
 */
export type SnapshotContentResponse = Message<"lvdr.v2.workspace.SnapshotContentResponse"> & {
  /**
   * @generated from field: lvdr.v2.workspace.Snapshot snapshot = 1;
   */
  snapshot?: Snapshot | undefined;

  /**
   * @generated from field: bytes content = 2;
   */
  content: Uint8Array;
};

/**
 * Describes the message lvdr.v2.workspace.SnapshotContentResponse.
 * Use `create(SnapshotContentResponseSchema)` to create a new message.
 */
export const SnapshotContentResponseSchema: GenMessage<SnapshotContentResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 33);

/**
 * @generated from message lvdr.v2.workspace.ListSnapshotsRequest
 */
export type ListSnapshotsRequest = Message<"lvdr.v2.workspace.ListSnapshotsRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.workspace.ListSnapshotsRequest.
 * Use `create(ListSnapshotsRequestSchema)` to create a new message.
 */
export const ListSnapshotsRequestSchema: GenMessage<ListSnapshotsRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 34);

/**
 * @generated from message lvdr.v2.workspace.ListSnapshotsResponse
 */
export type ListSnapshotsResponse = Message<"lvdr.v2.workspace.ListSnapshotsResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: repeated lvdr.v2.workspace.Snapshot snapshots = 2;
   */
  snapshots: Snapshot[];
};

/**
 * Describes the message lvdr.v2.workspace.ListSnapshotsResponse.
 * Use `create(ListSnapshotsResponseSchema)` to create a new message.
 */
export const ListSnapshotsResponseSchema: GenMessage<ListSnapshotsResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 35);

/**
 * @generated from message lvdr.v2.workspace.AddSnapshotTagRequest
 */
export type AddSnapshotTagRequest = Message<"lvdr.v2.workspace.AddSnapshotTagRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId: string;

  /**
   * @generated from field: lvdr.v2.workspace.SnapshotTag tag = 3;
   */
  tag?: SnapshotTag | undefined;
};

/**
 * Describes the message lvdr.v2.workspace.AddSnapshotTagRequest.
 * Use `create(AddSnapshotTagRequestSchema)` to create a new message.
 */
export const AddSnapshotTagRequestSchema: GenMessage<AddSnapshotTagRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 36);

/**
 * @generated from message lvdr.v2.workspace.SetSnapshotLegalHoldRequest
 */
export type SetSnapshotLegalHoldRequest = Message<"lvdr.v2.workspace.SetSnapshotLegalHoldRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string snapshot_id = 2;
   */
  snapshotId: string;

  /**
   * @generated from field: bool legal_hold = 3;
   */
  legalHold: boolean;
};

/**
 * Describes the message lvdr.v2.workspace.SetSnapshotLegalHoldRequest.
 * Use `create(SetSnapshotLegalHoldRequestSchema)` to create a new message.
 */
export const SetSnapshotLegalHoldRequestSchema: GenMessage<SetSnapshotLegalHoldRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 37);

/**
 * SnapshotResponse is the metadata-only ack for create / add-tag / set-hold.
 *
 * @generated from message lvdr.v2.workspace.SnapshotResponse
 */
export type SnapshotResponse = Message<"lvdr.v2.workspace.SnapshotResponse"> & {
  /**
   * @generated from field: lvdr.v2.workspace.Snapshot snapshot = 1;
   */
  snapshot?: Snapshot | undefined;
};

/**
 * Describes the message lvdr.v2.workspace.SnapshotResponse.
 * Use `create(SnapshotResponseSchema)` to create a new message.
 */
export const SnapshotResponseSchema: GenMessage<SnapshotResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 38);

/**
 * ExportWorkspaceRequest asks the server to assemble a full archive of one
 * Workspace island the caller has MOUNTED in this session (the session keyring
 * holds the WS-DEK — export is an owner-session feature; the detached GDPR
 * eraser never holds a DEK and therefore refuses while a legal hold exists).
 * Any grant level suffices (read is enough to see everything the archive holds).
 *
 * @generated from message lvdr.v2.workspace.ExportWorkspaceRequest
 */
export type ExportWorkspaceRequest = Message<"lvdr.v2.workspace.ExportWorkspaceRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;
};

/**
 * Describes the message lvdr.v2.workspace.ExportWorkspaceRequest.
 * Use `create(ExportWorkspaceRequestSchema)` to create a new message.
 */
export const ExportWorkspaceRequestSchema: GenMessage<ExportWorkspaceRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 39);

/**
 * ExportWorkspaceResponse carries the assembled ZIP (built in memory, size-capped
 * server-side) plus the suggested client filename. The client saves it as a Blob
 * download; the server retains nothing (LumaVista is not a legal archive).
 *
 * @generated from message lvdr.v2.workspace.ExportWorkspaceResponse
 */
export type ExportWorkspaceResponse = Message<"lvdr.v2.workspace.ExportWorkspaceResponse"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * the complete ZIP bytes
   *
   * @generated from field: bytes archive = 2;
   */
  archive: Uint8Array;

  /**
   * suggested download name
   *
   * @generated from field: string filename = 3;
   */
  filename: string;
};

/**
 * Describes the message lvdr.v2.workspace.ExportWorkspaceResponse.
 * Use `create(ExportWorkspaceResponseSchema)` to create a new message.
 */
export const ExportWorkspaceResponseSchema: GenMessage<ExportWorkspaceResponse> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 40);

/**
 * @generated from message lvdr.v2.workspace.CreateWorkspaceNoteSnapshotRequest
 */
export type CreateWorkspaceNoteSnapshotRequest = Message<"lvdr.v2.workspace.CreateWorkspaceNoteSnapshotRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string note_id = 2;
   */
  noteId: string;

  /**
   * "manual" | "pre-restore" (server stamps cadence ones)
   *
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message lvdr.v2.workspace.CreateWorkspaceNoteSnapshotRequest.
 * Use `create(CreateWorkspaceNoteSnapshotRequestSchema)` to create a new message.
 */
export const CreateWorkspaceNoteSnapshotRequestSchema: GenMessage<CreateWorkspaceNoteSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 41);

/**
 * @generated from message lvdr.v2.workspace.ListWorkspaceNoteSnapshotsRequest
 */
export type ListWorkspaceNoteSnapshotsRequest = Message<"lvdr.v2.workspace.ListWorkspaceNoteSnapshotsRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string note_id = 2;
   */
  noteId: string;
};

/**
 * Describes the message lvdr.v2.workspace.ListWorkspaceNoteSnapshotsRequest.
 * Use `create(ListWorkspaceNoteSnapshotsRequestSchema)` to create a new message.
 */
export const ListWorkspaceNoteSnapshotsRequestSchema: GenMessage<ListWorkspaceNoteSnapshotsRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 42);

/**
 * @generated from message lvdr.v2.workspace.GetWorkspaceNoteSnapshotRequest
 */
export type GetWorkspaceNoteSnapshotRequest = Message<"lvdr.v2.workspace.GetWorkspaceNoteSnapshotRequest"> & {
  /**
   * @generated from field: string workspace_id = 1;
   */
  workspaceId: string;

  /**
   * @generated from field: string note_id = 2;
   */
  noteId: string;

  /**
   * @generated from field: string snapshot_id = 3;
   */
  snapshotId: string;
};

/**
 * Describes the message lvdr.v2.workspace.GetWorkspaceNoteSnapshotRequest.
 * Use `create(GetWorkspaceNoteSnapshotRequestSchema)` to create a new message.
 */
export const GetWorkspaceNoteSnapshotRequestSchema: GenMessage<GetWorkspaceNoteSnapshotRequest> = /*@__PURE__*/
  messageDesc(file_workspace_workspace, 43);

